export enum DeviceLinkActionTypes {
    SET_DEVICE_LINKS = "SET_DEVICE_LINKS",
    CLEAR_DEVICE_LINKS = "CLEAR_DEVICE_LINKS"
}